import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';

import {
  GeneralInfo,
  Summary
} from './Detail';

import InvoiceItems from '../Invoice/InvoiceItems';
import InvoicePayments from '../Invoice/InvoicePayments2';
import InvoiceSummary from '../Invoice/InvoiceSummary';
import { Section } from '../ContentEdit';

const styles = theme => ({
  root: {
  },
  card: {
  },
  content: {
    padding: '0px',
  }
});

const InvoiceDetail = ({ classes, invoice, preview = false }) => {
  return(
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <GeneralInfo heading="INVOICE" preview={preview} />
          <Section
            preview={false}
            title="Line Items"
            showContent={true}
            showAdd={false}
            >
            <InvoiceItems preview={preview} />
          </Section>
          <Section
            preview={false}
            title="Payments"
            showContent={true}
            showAdd={false}
            >
            <InvoicePayments preview={preview} />
          </Section>
          <Section
            preview={false}
            title="Summary"
            showContent={true}
            showAdd={false}
            >
            <InvoiceSummary preview={preview} />
          </Section>
        </CardContent>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => ({
  invoice: state.invoicesState.find(invoice => invoice.id === state.adminState.invoice.id),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(InvoiceDetail);



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/InvoiceDetail.jsx